import type { ReactNode } from 'react';

/** Shared table surface. Grid definitions stay page-specific while scrolling, borders and base table semantics remain consistent. */
export function DataTable({children,className=''}:{children:ReactNode;className?:string}){
  return <div className={`table dataTable ${className}`.trim()}>{children}</div>;
}
